module.exports = __webpack_public_path__ + "media/images/icons/fb-blue-color-b90b679a558debad3fd1edcd66ba209d.svg";